import {
  DailyReportDetailSection,
  DailyReportHeaderSection,
  InsufficientAccessBackground,
  StyledActivityCardBackground,
  useAccessState
} from 'modules';
import React from 'react';



export type DailyReportActivityProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const DailyReportActivity = (props: DailyReportActivityProps) => {
  const access = useAccessState('DailyReport');
  if (!access.view) {
    return (
      <InsufficientAccessBackground.FC />
    );
  }
  return (
    <StyledActivityCardBackground.FC>
      <DailyReportHeaderSection.FC />
      <DailyReportDetailSection.FC />
    </StyledActivityCardBackground.FC>
  );
};
